import { AllCaseOrderOptionsDTO } from '@/generated'
import type { VitalSignsSortBy } from '@/stores/models/VitalSignsSortBy'

export interface VitalSignsSortOption {
  label: string
  value: VitalSignsSortBy
}

export const getVitalSignsSortByOptions = (t: (key: string) => string): VitalSignsSortOption[] => [
  {
    label: t('Ascending Patient Name'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.PATIENT_NAME,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Descending Patient Name'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.PATIENT_NAME,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Highest Heart Rate'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.HEART_RATE,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Heart Rate'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.HEART_RATE,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Respiratory Rate'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.RR,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Respiratory Rate'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.RR,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Body Temperature'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.TEMP,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Body Temperature'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.TEMP,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Systolic Arterial Pressure'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.INV_S_BP,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Systolic Arterial Pressure'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.INV_S_BP,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Diastolic Arterial Pressure'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.INV_D_BP,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Diastolic Arterial Pressure'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.INV_D_BP,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Mean Arterial Pressure'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.INV_M_BP,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Mean Arterial Pressure'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.INV_M_BP,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Systolic Blood Pressure Non-invasive'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.NON_INV_S_BP,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Systolic Blood Pressure Non-invasive'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.NON_INV_S_BP,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Diastolic Blood Pressure Non-invasive'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.NON_INV_D_BP,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Diastolic Blood Pressure Non-invasive'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.NON_INV_D_BP,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Highest Peripheral Oxygen Saturation'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.SPO2,
      sortDirection: 'DESCENDING'
    }
  },
  {
    label: t('Lowest Peripheral Oxygen Saturation'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.SPO2,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Ascending Organ Support'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.ORGAN_SUPPORT,
      sortDirection: 'ASCENDING'
    }
  },
  {
    label: t('Descending Organ Support'),
    value: {
      sortBy: AllCaseOrderOptionsDTO.ORGAN_SUPPORT,
      sortDirection: 'DESCENDING'
    }
  }
]
